var size = {
    xs: "320px",
    sm: "576px",
    md: "768px",
    lg: "1024px",
    xl: "1200px",
    xxl: "1400px",
    mds: "360px",
    mvmd: "430px",
};
var device = {
    xs: "(max-width: ".concat(size.xs, ")"),
    sm: "(max-width: ".concat(size.sm, ")"),
    md: "(max-width: ".concat(size.md, ")"),
    lg: "(max-width: ".concat(size.lg, ")"),
    xl: "(max-width: ".concat(size.xl, ")"),
    xxl: "(max-width: ".concat(size.xxl, ")"),
    mds: "(max-width: ".concat(size.mds, ")"),
    ipads: "(min-height: ".concat(size.lg, ")"),
    mvmd: "(max-width: ".concat(size.mvmd, ")"),
    llg: "(min-width: ".concat(size.lg, ")"),
};
export default { size: size, device: device };
